// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let ReactRelay = require("react-relay");
let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");

function makeRefetchVariables() {
  
}

let Types = {
  makeRefetchVariables: makeRefetchVariables
};

let variablesConverter = {};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

let wrapResponseConverter = {"__root":{"localDraft_updatedAt":{"b":""},"localDraft":{"f":""}}};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, undefined, null);
}

let responseConverter = {"__root":{"localDraft_updatedAt":{"b":""},"localDraft":{"f":""}}};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, undefined, undefined);
}

let wrapRawResponseConverter = {"__root":{"localDraft_updatedAt":{"b":""},"localDraft_draftProperty_showings_date":{"b":""},"localDraft_draftProperty_onMlsAt":{"b":""},"localDraft_draftProperty_availableFrom":{"b":""}}};

function convertWrapRawResponse(v) {
  return RescriptRelay.convertObj(v, wrapRawResponseConverter, undefined, null);
}

let rawResponseConverter = {"__root":{"localDraft_updatedAt":{"b":""},"localDraft_draftProperty_showings_date":{"b":""},"localDraft_draftProperty_onMlsAt":{"b":""},"localDraft_draftProperty_availableFrom":{"b":""}}};

function convertRawResponse(v) {
  return RescriptRelay.convertObj(v, rawResponseConverter, undefined, undefined);
}

let Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: undefined,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: undefined,
  convertResponse: convertResponse,
  wrapRawResponseConverter: wrapRawResponseConverter,
  wrapRawResponseConverterMap: undefined,
  convertWrapRawResponse: convertWrapRawResponse,
  rawResponseConverter: rawResponseConverter,
  rawResponseConverterMap: undefined,
  convertRawResponse: convertRawResponse
};

function draftV5Status_decode($$enum) {
  if ($$enum === "DELETED" || $$enum === "RESUMABLE_DRAFT" || $$enum === "DRAFT" || $$enum === "PUBLISHED" || $$enum === "EXPIRED") {
    return $$enum;
  }
}

let draftV5Status_fromString = draftV5Status_decode;

function forSalePropertyTypeEnumV5_decode($$enum) {
  if ($$enum === "CONDO" || $$enum === "SINGLE_FAMILY" || $$enum === "LOT" || $$enum === "MULTI_UNIT") {
    return $$enum;
  }
}

let forSalePropertyTypeEnumV5_fromString = forSalePropertyTypeEnumV5_decode;

function leaseLengthValue_decode($$enum) {
  if ($$enum === "LONG" || $$enum === "SHORT_OR_LONG" || $$enum === "SHORT") {
    return $$enum;
  }
}

let leaseLengthValue_fromString = leaseLengthValue_decode;

function localDraftPropertyType_decode($$enum) {
  if ($$enum === "FOR_SALE" || $$enum === "RENTAL") {
    return $$enum;
  }
}

let localDraftPropertyType_fromString = localDraftPropertyType_decode;

function lotSizeUnit_decode($$enum) {
  if ($$enum === "ACRE" || $$enum === "SQ_FT") {
    return $$enum;
  }
}

let lotSizeUnit_fromString = lotSizeUnit_decode;

function mlsListingTypeV5_decode($$enum) {
  if ($$enum === "ACTIVE" || $$enum === "OFF_MLS" || $$enum === "COMING_SOON") {
    return $$enum;
  }
}

let mlsListingTypeV5_fromString = mlsListingTypeV5_decode;

function rentalPropertyTypeEnumV5_decode($$enum) {
  if ($$enum === "CONDO" || $$enum === "SINGLE_FAMILY") {
    return $$enum;
  }
}

let rentalPropertyTypeEnumV5_fromString = rentalPropertyTypeEnumV5_decode;

function showingTypeV5_decode($$enum) {
  if ($$enum === "AGENTS_ONLY" || $$enum === "TAN_ONLY" || $$enum === "BUYERS_WELCOME") {
    return $$enum;
  }
}

let showingTypeV5_fromString = showingTypeV5_decode;

let Utils = {
  draftV5Status_decode: draftV5Status_decode,
  draftV5Status_fromString: draftV5Status_fromString,
  forSalePropertyTypeEnumV5_decode: forSalePropertyTypeEnumV5_decode,
  forSalePropertyTypeEnumV5_fromString: forSalePropertyTypeEnumV5_fromString,
  leaseLengthValue_decode: leaseLengthValue_decode,
  leaseLengthValue_fromString: leaseLengthValue_fromString,
  localDraftPropertyType_decode: localDraftPropertyType_decode,
  localDraftPropertyType_fromString: localDraftPropertyType_fromString,
  lotSizeUnit_decode: lotSizeUnit_decode,
  lotSizeUnit_fromString: lotSizeUnit_fromString,
  mlsListingTypeV5_decode: mlsListingTypeV5_decode,
  mlsListingTypeV5_fromString: mlsListingTypeV5_fromString,
  rentalPropertyTypeEnumV5_decode: rentalPropertyTypeEnumV5_decode,
  rentalPropertyTypeEnumV5_fromString: rentalPropertyTypeEnumV5_fromString,
  showingTypeV5_decode: showingTypeV5_decode,
  showingTypeV5_fromString: showingTypeV5_fromString
};

let node = ((function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serverDraftId",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fileName",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contentType",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "PropertyWizardFormRelayQuery",
    "selections": [
      {
        "kind": "ClientExtension",
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "LocalDraft",
            "kind": "LinkedField",
            "name": "localDraft",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              (v1/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "PropertyWizardFormRelay_localDraft"
              }
            ],
            "storageKey": null
          }
        ]
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "PropertyWizardFormRelayQuery",
    "selections": [
      {
        "kind": "ClientExtension",
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "LocalDraft",
            "kind": "LinkedField",
            "name": "localDraft",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "subject",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "timeZone",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "chapterPreferenceMlsComingSoonActivated",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "message",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "LocalDraftProperty",
                "kind": "LinkedField",
                "name": "draftProperty",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "website",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LocalGeocodingData",
                    "kind": "LinkedField",
                    "name": "geocodingData",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "lat",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "lon",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "standardizedAddress",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "standardizedCity",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "standardizedState",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "standardizedZip",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LocalDraftAttachment",
                    "kind": "LinkedField",
                    "name": "files",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      (v4/*: any*/),
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LocalDraftAttachment",
                    "kind": "LinkedField",
                    "name": "images",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      (v4/*: any*/),
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "previewUrl",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LocalDraftShowing",
                    "kind": "LinkedField",
                    "name": "showings",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endTime",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "notes",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "startTime",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "type_",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "date",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "description",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LocalDisplayNeighborhood",
                    "kind": "LinkedField",
                    "name": "displayNeighborhood",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "address",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "addressToGeocode",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "anonymousProperty",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hideAddress",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LocalDraftSelectedArea",
                    "kind": "LinkedField",
                    "name": "selectedArea",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "propertyType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "commission",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "availableFrom",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "leaseLength",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "price",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "priceRange",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "minPrice",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "maxPrice",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "forSalePropertyType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "rentalPropertyType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "baths",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "beds",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "halfBaths",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "livingArea",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lotSize",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lotSizeUnit",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "numberOfUnits",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "parkingSpaces",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "parkingDetails",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "goingOnMls",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "willAcceptOffers",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "willShow",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "mlsListingType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "onMlsAt",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "f1ec1a79e74ecddc59b95700d9d7aea0",
    "id": null,
    "metadata": {},
    "name": "PropertyWizardFormRelayQuery",
    "operationKind": "query",
    "text": null
  }
};
})());

function load(environment, variables, fetchPolicy, fetchKey, networkCacheConfig) {
  return ReactRelay.loadQuery(environment, node, convertVariables(variables), {
    fetchKey: fetchKey,
    fetchPolicy: fetchPolicy,
    networkCacheConfig: networkCacheConfig
  });
}

function queryRefToObservable(token) {
  return Primitive_option.fromNullable(token.source);
}

function queryRefToPromise(token) {
  return new Promise((resolve, _reject) => {
    let o = queryRefToObservable(token);
    if (o !== undefined) {
      Primitive_option.valFromOption(o).subscribe({
        complete: () => resolve({
          TAG: "Ok",
          _0: undefined
        })
      });
      return;
    } else {
      return resolve({
        TAG: "Error",
        _0: undefined
      });
    }
  });
}

exports.Types = Types;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
exports.load = load;
exports.queryRefToObservable = queryRefToObservable;
exports.queryRefToPromise = queryRefToPromise;
/* node Not a pure module */
